import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { Moon, ShieldCheck, Star } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-16 pb-24 lg:pt-24 lg:pb-32 overflow-hidden" data-id="element-111">
      {/* Background glow effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-blue-900/20 blur-[120px] rounded-full pointer-events-none" data-id="element-112"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-113">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-114">
          {/* Text Content */}
          <div className="max-w-2xl mx-auto lg:mx-0 text-center lg:text-left" data-id="element-115">
            <FadeIn data-id="element-116">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-800/80 border border-slate-700 text-amber-400 text-sm font-medium mb-6" data-id="element-117">
                <Moon className="w-4 h-4" data-id="element-118" />
                <span data-id="element-119">El kit de primeros auxilios digital</span>
              </div>
            </FadeIn>

            <FadeIn delay={100} data-id="element-120">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-[1.1] mb-6 tracking-tight" data-id="element-121">
                ¿OTRA NOCHE MÁS{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600" data-id="element-122">
                  SIN PODER DORMIR?
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={200} data-id="element-123">
              <p className="text-lg sm:text-xl text-slate-300 mb-8 leading-relaxed" data-id="element-124">
                Cómo Resetear tu Sistema Nervioso y Volver a Dormir Profundo en
                Menos de 7 Días...{' '}
                <strong className="text-white font-semibold" data-id="element-125">
                  Sin Pastillas, Sin Apps Aburridas y Sin Sesiones Eternas de
                  Terapia.
                </strong>
              </p>
            </FadeIn>

            <FadeIn delay={300} data-id="element-126">
              <div className="bg-slate-800/50 border-l-4 border-amber-500 p-4 rounded-r-lg mb-8 text-left" data-id="element-127">
                <p className="text-slate-300 italic" data-id="element-128">
                  El "Protocolo Reinicio" es el kit diseñado para argentinos
                  "quemados" que necesitan calma real...{' '}
                  <strong className="text-amber-400" data-id="element-129">ESTA MISMA NOCHE.</strong>
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={400} className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start" data-id="element-130">
              <CTAButton onClick={scrollToPricing} data-id="element-131">
                SÍ, QUIERO EMPEZAR ESTA NOCHE
              </CTAButton>
              <div className="flex items-center gap-2 text-sm text-slate-400" data-id="element-132">
                <ShieldCheck className="w-5 h-5 text-emerald-500" data-id="element-133" />
                <span data-id="element-134">Garantía de 7 días</span>
              </div>
            </FadeIn>

            <FadeIn delay={500} className="mt-8 flex items-center justify-center lg:justify-start gap-4" data-id="element-135">
              <div className="flex -space-x-2" data-id="element-136">
                {[1, 2, 3, 4, 5].map(i => <div key={i} className={`w-8 h-8 rounded-full border-2 border-[#0a0e1a] bg-slate-700 flex items-center justify-center overflow-hidden`} data-id="element-137">
                    <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="User" className="w-full h-full object-cover opacity-80" data-id="element-138" />
                  </div>)}
              </div>
              <div className="text-sm" data-id="element-139">
                <div className="flex text-amber-400" data-id="element-140">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-141" />)}
                </div>
                <span className="text-slate-400" data-id="element-142">
                  +2,400 argentinos ya lo probaron
                </span>
              </div>
            </FadeIn>
          </div>

          {/* Image Mockup */}
          <FadeIn delay={200} direction="left" className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-143">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-slate-800/50 group" data-id="element-144">
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e1a] via-transparent to-transparent z-10" data-id="element-145"></div>
              <img src="https://cdn.magicpatterns.com/uploads/hugNnkWwLfmdfGSQgSwPnH/Portada_4.png" alt="Protocolo Reinicio Ebook en iPad" className="w-full h-auto object-cover transform transition-transform duration-700 group-hover:scale-105" data-id="element-146" />
              {/* Subtle reflection/glare effect */}
              <div className="absolute inset-0 bg-gradient-to-tr from-white/5 via-transparent to-white/10 z-20 pointer-events-none" data-id="element-147"></div>
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-slate-800 border border-slate-700 p-4 rounded-xl shadow-xl z-30 animate-bounce" style={{
            animationDuration: '3s'
          }} data-id="element-148">
              <p className="text-xs text-slate-400 font-medium mb-1" data-id="element-149">
                Valor Total
              </p>
              <p className="text-lg font-bold text-white line-through decoration-red-500/70" data-id="element-150">
                $55.000 ARS
              </p>
              <p className="text-2xl font-extrabold text-emerald-400 mt-1" data-id="element-151">
                HOY $9.90 USD
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}